exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".compact.card-header{background-color:#f5f5f5}.compact.card-header-title{padding-top:1px;padding-bottom:1px}.compact.card-content{padding:.75rem 1.5rem}.compact.card-footer-item{padding-top:0;padding-bottom:0}.is-info.card-footer-item{background-color:#209cee;color:#fff}.is-danger.card-footer-item{background-color:#ff3860;color:#fff}.has-black.card-footer-item{color:#000}.compact.tags,.compact.tags:not(:last-child){margin-bottom:0}.compact.tags{flex-wrap:nowrap;flex-grow:0}.compact .tag{margin-bottom:0}.card .mouse-detrav-hover{display:none}.card:hover .mouse-detrav-hover{display:flex}.clipped-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0;margin:auto;flex-grow:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader!./src/components/ChangeCard.Vue?vue&type=style&index=0&lang=css
// module id = 158
// module chunks = 0